export function toDisposable(fn) {
  let done = false
  return {
    dispose() {
      if (done) return
      done = true
      fn()
    },
  }
}

// Collects every registration a plugin makes so deactivation can undo all of
// them even when the plugin forgets to clean up.
export class DisposableStore {
  #items = new Set()
  #disposed = false

  add(disposable) {
    if (this.#disposed) {
      disposable.dispose()
      return disposable
    }
    this.#items.add(disposable)
    return toDisposable(() => {
      this.#items.delete(disposable)
      disposable.dispose()
    })
  }

  dispose() {
    if (this.#disposed) return
    this.#disposed = true
    for (const item of this.#items) {
      try {
        item.dispose()
      } catch (err) {
        console.error('[omni] dispose failed', err)
      }
    }
    this.#items.clear()
  }
}
